<template>
    <div id="content">
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               @popup-action="executePopupAction" />

        <div class="inner">
            <p class="buttons">
                <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate" @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
            </p>

            <h1>{{ entity.name }}</h1>
        </div>

        <div class="responsiveTabs">

            <ul class="tabs">
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceTypeDetailDescription'}"><a @click.stop="openRoute('deviceTypeDetail')" v-translate>Vlastnosti</a></li>
                <li v-if="$_loggedUser_action_allowed('streamProfiles')" :class="{'r-tabs-state-active' : this.$route.name === 'deviceTypeDetailStreams'}">
                  <a @click.stop="openRoute('deviceTypeDetailStreams')" v-translate>Profily streamů</a>
                </li>
            </ul>

            <router-view
                :entity="entity"
                :deviceGroups="this.deviceGroups"
                :protocols="protocols"
                :codecs="codecs"
                :streamProfiles="streamProfiles"
                :is-editable="$_updateActionAllowed"
            />

            <section class="buttons">
                <p>
                    <a class="btn btn_back btn_seznam" @click.stop="showDeviceTypeList" v-translate>Seznam typů zařízení</a>
                    <input
                        v-if="$_updateActionAllowed"
                        type="submit"
                           :value="'Uložit' | translate"
                           :class="['btn']"
                           @click.prevent.stop="submitForm()">
                </p>
            </section>
        </div>
    </div>
</template>

<script>
import deviceTypes from "@/components/views/deviceTypes/mixins/deviceTypes"
import detailActions from "@/components/mixins/detail-actions"

export default {
    name: "DeviceTypeDetail",
    components: {},
    data () {
        return {
            codecs: [],
            deviceGroups: [],
            protocols: [],
            streamProfiles: [],
        }
    },
    mixins: [detailActions, deviceTypes],
    created(DeviceTypeService) {
        this.entityService = DeviceTypeService

        this.getDependency().then(() => {
            this.createdInit();
        });
    },
    methods: {
        _processDetailErrorMessage(error) {
            return this.processErrorMessage(error)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceTypes/DeviceTypeDetail.vue